import { j as e } from "../../jsx-runtime-BwWtxLpl.js";
import j, { useState as k, useCallback as N, useContext as L } from "react";
import { MotifIcon as T } from "../icon/icon.js";
import { IconContext as A } from "../icon/icon.context.js";
import o from "prop-types";
import p from "classnames";
import { IconoirXmark as D } from "@ey-xd/motif-icon";
const V = {
  close: D
}, M = (B) => {
  const {
    children: u,
    className: f,
    disabled: t,
    icons: h,
    onClick: r,
    removable: l,
    type: v,
    dotSide: a,
    variant: s,
    onRemove: b,
    dropdown: i,
    closeButtonProps: E,
    ...x
  } = B, [I, P] = k(!0), [R, g] = k(!1), n = N(() => g(!0), []), c = N(() => g(!1), []), { chip: C } = L(A);
  let d;
  C ? d = {
    ...C,
    ...h
  } : d = {
    ...V,
    ...h
  };
  const w = (m) => {
    m.stopPropagation(), P(!1), b && b();
  }, y = p({
    "motif-chip": !0,
    "motif-chip-active": R,
    "motif-chip-disabled": t,
    "motif-chip-dropdown": i,
    "motif-chip-outlined": v === "outlined",
    "motif-ghost": t,
    [f]: !0
  }), F = p({
    "motif-dot": !0,
    "motif-dot-disabled": t,
    [`motif-dot-${s}`]: s,
    [`motif-dot-${a}`]: a,
    "motif-chip-button": !0,
    "motif-chip-interactive": !0,
    "motif-chip-clickable": r,
    "motif-chip-removable": l,
    [`motif-chip-${s}`]: s
  }), O = p({
    "motif-dot": !0,
    "motif-dot-disabled": t,
    [`motif-dot-${s}`]: s,
    [`motif-dot-${a || "left"}`]: !0,
    [f]: !0
  }), $ = I ? /* @__PURE__ */ e.jsx("div", { className: y, "data-motif-chip": !0, children: /* @__PURE__ */ e.jsxs(
    "div",
    {
      ...(l || i || r) && !t ? { tabIndex: 0 } : {},
      ...x,
      className: F,
      onBlur: c,
      onClick: r,
      onFocus: n,
      onMouseEnter: n,
      onMouseLeave: c,
      children: [
        u,
        i && j.cloneElement(i, {
          trigger: j.cloneElement(i.props.trigger, {
            onBlur: c,
            onFocus: n,
            onMouseEnter: n,
            onMouseLeave: c
          })
        }),
        l && !i && /* @__PURE__ */ e.jsx(
          "button",
          {
            "aria-label": "close chip",
            className: "motif-close-icon",
            disabled: t,
            onBlur: c,
            onClick: (m) => w(m),
            onFocus: n,
            onMouseEnter: n,
            onMouseLeave: c,
            ...E,
            children: /* @__PURE__ */ e.jsx(T, { iconFunction: d.close, strokeWidth: "1.5px" })
          }
        )
      ]
    }
  ) }) : /* @__PURE__ */ e.jsx(e.Fragment, {}), S = /* @__PURE__ */ e.jsx("div", { className: O, ...x, "data-motif-chip": !0, children: /* @__PURE__ */ e.jsx("span", { className: "motif-dot-text", children: u }) });
  return v === "dot" ? S : $;
};
M.propTypes = {
  /**
   * The content of the component.
   */
  children: o.node,
  /**
   * Custom CSS classes to be added to the chip.
   */
  className: o.string,
  /**
   * Custom props to be added to the close button.
   */
  closeButtonProps: o.instanceOf(Object),
  /**
   * Whether the chip is disabled.
   */
  disabled: o.bool,
  /**
   * Custom icons to be used for the chip.
   */
  icons: o.shape({
    close: o.node
  }),
  /**
   * MotifDropdown component to be rendered when the chip is clicked.
   */
  dropdown: o.node,
  /**
   * Callback fired when the chip is clicked, cursor changes to pointer.
   */
  onClick: o.func,
  /**
   * Callback fired when the chip is removed.
   */
  onRemove: o.func,
  /**
   * Whether the chip is removable.
   */
  removable: o.bool,
  /**
   * The type of chip to render.
   */
  type: o.oneOf(["chip", "dot", "outlined"]),
  /**
   * Side where the dot is rendered when type is 'dot'.
   */
  dotSide: o.oneOf(["none", "left", "right"]),
  /**
   * The variant of the chip.
   */
  variant: o.oneOf(["success", "warning", "error", "monochrome-light", "monochrome-dark"])
};
M.defaultProps = {
  children: null,
  className: "",
  closeButtonProps: {},
  disabled: !1,
  icons: {},
  onClick: null,
  onRemove: null,
  removable: !1,
  type: "chip",
  dotSide: "",
  variant: null,
  dropdown: null
};
export {
  M as MotifChip
};
